<template>
  <div class="container mb-5">
    <!-- {{ join_category_4_frm_disp }} -->
    <div class="row" v-if="!request_mode">
      <div class="col-8">
        <div><h5>継続・追加承認</h5></div>
        <div>
          <div class="bg-light border alert">
            この申請には以下のものがふくまれています
            <hr />
            <span v-if="join_category_frm_disp(3)">新規ライセンス申請</span>
            <span v-if="join_category_frm_disp(4)">追加ライセンス申請</span>
            <span v-if="join_category_frm_disp(5)">継続ライセンス申請</span>
          </div>
        </div>
        <!-- {{ draft_orders }} -->
        <div class="container mb-4 pt-2 border border-2">
          <div class="row mb-2 pb-2">
            <div class="col-12 border-bottom">会員情報</div>
          </div>
          <div class="row mb-2" v-if="app_data?.member?.trans_period == 1">
            <div class="col">
              <p class="alert warning">12/23-翌1/31以降パッケージ料金対象者</p>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-2">
              <p class="form-control-plaintext">ライセンスNo</p>
            </div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{ app_data?.member?.license_no }}
              </p>
            </div>
            <div class="col-2">
              <p class="form-control-plaintext">氏名 (かな)</p>
            </div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{ (app_data.member || {}).name_label }} ({{
                  (app_data.member || {}).yomi_label
                }})
              </p>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-2">
              <p class="form-control-plaintext">生年月日</p>
            </div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{ (app_data.member || {}).birth_date_label }}
              </p>
            </div>
            <div class="col-2">
              <p class="form-control-plaintext">性別</p>
            </div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{ (app_data.member || {}).sex_type_label }}
              </p>
            </div>
          </div>
        </div>
        <div class="container mb-4 pt-2 border border-2">
          <!-- {{ app_data }} -->
          <div class="row mb-2 pb-2">
            <div class="col-12 border-bottom">所有ライセンス一覧</div>
          </div>
          <div class="row">
            <!-- {{ app_data.member.member_license }} -->
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="">年度</th>
                  <th class="">種別</th>
                  <th class="">ライセンス</th>
                  <th style="width: 40%">期間</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="license_class in [1, 4, 2, 3]">
                  <tr
                    v-for="license in license_filter_sort(license_class)"
                    :key="license"
                  >
                    <td>{{ license.license_year }}</td>
                    <td>
                      <span v-if="license_class == 1">競技ライセンス</span>
                      <span v-else-if="license_class == 4">ピットクルー</span>
                      <span v-else-if="license_class == 2">競技役員</span>
                      <span v-else-if="license_class == 3">講師</span>
                    </td>
                    <td>{{ license.short_label }}</td>
                    <td>
                      {{ license.license_term_start_date }}
                      <span class="">〜</span>
                      {{ license.license_term_end_date }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 3時間 -->
        <div v-if="join_3hour_frm_disp">走行証明関連</div>
        <div class="mb-4 pt-2 border border-2" v-if="join_3hour_frm_disp">
          <div
            class="container mb-2 border-bottom"
            v-for="variant in get_selected_variants_filter({ join_3hour: 1 })"
            :key="variant"
          >
            <div class="row border-bottom border-dotted">
              <div class="col-4 mb-2">
                {{ variant.license_label }}
              </div>
              <div class="col-4 mb-2">
                <label class="badge bg-secondary">公認サーキット</label>
                <input
                  :value="
                    get_list_label(variant.join_3hour_circuit_id, circuit_list)
                  "
                  class="form-control-plaintext"
                  readonly="true"
                />
              </div>
              <div class="col-4 mb-2">
                <label class="badge bg-secondary"
                  >サーキットライセンスNo.</label
                >
                <input
                  :value="variant.join_3hour_circuit_license_no"
                  class="form-control-plaintext"
                  readonly="true"
                />
              </div>
              <div class="col-4 offset-4 mb-2">
                <label class="badge bg-secondary">ライセンス画像</label>
                <div
                  class="w-100"
                  v-if="
                    typeof get_app_item('mfj_member_assets@path10') ===
                      'object' &&
                    isImage(
                      get_app_item('mfj_member_assets@path10').application_value
                    )
                  "
                >
                  <ImageWithZoom
                    :image-src="
                      (get_app_item('mfj_member_assets@path10') || {})
                        .application_value || ''
                    "
                    image-class="w-100"
                    image-alt="ライセンス画像"
                    modal-title="ライセンス画像"
                    :loading="false"
                    @error="handleImageError"
                  />
                </div>
                <div
                  v-else-if="
                    typeof get_app_item('mfj_member_assets@path10') === 'object'
                  "
                  class="text-muted"
                >
                  <a
                    :href="
                      get_app_item('mfj_member_assets@path10').application_value
                    "
                    target="_blank"
                    >書類を確認</a
                  >
                </div>
                <div v-else>未提出</div>
              </div>
              <div class="col-4 mb-2">
                <label class="badge bg-secondary">割引講習会受講証</label>
                <div
                  class="w-100"
                  v-if="
                    typeof get_app_item('mfj_member_assets@path11') ===
                      'object' &&
                    isImage(
                      get_app_item('mfj_member_assets@path11').application_value
                    )
                  "
                >
                  <ImageWithZoom
                    :image-src="
                      (get_app_item('mfj_member_assets@path11') || {})
                        .application_value || ''
                    "
                    image-class="w-100"
                    image-alt="割引講習会受講証"
                    modal-title="割引講習会受講証"
                    :loading="false"
                    @error="handleImageError"
                  />
                </div>
                <div
                  v-else-if="
                    typeof get_app_item('mfj_member_assets@path11') === 'object'
                  "
                  class="text-muted"
                >
                  <a
                    :href="
                      get_app_item('mfj_member_assets@path11').application_value
                    "
                    target="_blank"
                    >書類を確認</a
                  >
                </div>
                <div v-else>未提出</div>
              </div>
            </div>
            <div class="row">
              <div class="col-4">サーキット確認関連</div>
              <div class="col-8">
                <table class="table table-bordered w-100">
                  <tr>
                    <th>3時間走行確認依頼日時</th>
                    <th>3時間走行確認MFJ依頼者</th>
                  </tr>
                  <tr>
                    <td>
                      {{
                        variant.join_3hour_circuit_chk_req_date
                          ? variant.join_3hour_circuit_chk_req_date
                          : '--'
                      }}
                    </td>
                    <td>
                      {{
                        variant.join_3hour_circuit_chk_req_manage_id
                          ? variant.join_3hour_circuit_chk_req_manage_label
                          : app_data.edit_manage_label
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th>サーキット担当者</th>
                    <th>返答日時</th>
                  </tr>
                  <tr>
                    <td>
                      {{
                        variant.join_3hour_circuit_chk_ans_signature
                          ? variant.join_3hour_circuit_chk_ans_signature
                          : '--'
                      }}
                    </td>
                    <td>
                      {{
                        variant.join_3hour_circuit_chk_ans_date
                          ? variant.join_3hour_circuit_chk_ans_date
                          : '--'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th>返答1</th>
                    <th>返答2</th>
                  </tr>
                  <tr>
                    <td>
                      {{
                        variant.join_3hour_circuit_chk_ans_data_1
                          ? variant.join_3hour_circuit_chk_ans_data_1 == 1
                            ? '該当者有り'
                            : '該当者無し'
                          : '--'
                      }}
                    </td>
                    <td>
                      {{
                        variant.join_3hour_circuit_chk_ans_data_2
                          ? variant.join_3hour_circuit_chk_ans_data_2 == 1
                            ? '3時間以上'
                            : '3時間未満'
                          : '--'
                      }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="row mb-2 pb-2">
              <div
                class="col-1 offset-11"
                v-if="chk_checked_item('m_join_3hour')"
              >
                <div>
                  <button
                    :class="get_class_check_item_btn('m_join_3hour')"
                    @click="toggle_check_action('m_join_3hour')"
                  >
                    <i :class="get_class_check_item_icon('m_join_3hour')"></i>
                  </button>
                </div>
              </div>
              <div v-else class="col-3 offset-9">
                <div class="d-grid mb-2" v-if="!join_3hour_frm_circuit_chk_ok">
                  <button
                    v-if="edit_mode"
                    type="button"
                    class="btn btn-info"
                    @click="app_send_circuit_check()"
                  >
                    確認依頼を開く
                  </button>
                </div>
                <div class="" v-else>
                  <button
                    :class="get_class_check_item_btn('m_join_3hour')"
                    @click="toggle_check_action('m_join_3hour')"
                  >
                    <i :class="get_class_check_item_icon('m_join_3hour')"></i>
                  </button>
                </div>
                <div
                  class=""
                  v-if="!join_3hour_frm_circuit_chk_ok && edit_mode"
                >
                  <button
                    :class="get_class_check_item_btn('m_join_3hour')"
                    @click="toggle_check_action('m_join_3hour')"
                  >
                    <i :class="get_class_check_item_icon('m_join_3hour')"></i>
                    確認依頼を事後扱いで承認を進める
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 講習会 -->
        <div v-if="join_seminar_circuit_chk_disp">講習会</div>
        <div
          class="mb-4 pt-2 border-top border-start border-2"
          v-if="join_seminar_circuit_chk_disp"
        >
          <div
            class="container mb-2 border-bottom"
            v-for="variant in get_selected_variants_filter({
              join_seminar_type: 'circuit'
            })"
            :key="variant"
          >
            <div class="row border-bottom border-dotted">
              <div class="col-4 mb-2">
                {{ variant.license_label }}
              </div>
              <div class="col-4 mb-2">
                <label class="badge bg-secondary">受講した施設名</label>
                <input
                  :value="
                    get_list_label(variant.join_seminar_place, circuit_list)
                  "
                  v-if="
                    circuit_list.find(
                      circuit =>
                        circuit.stat == 1 &&
                        circuit.key == variant.join_seminar_place
                    )
                  "
                  class="form-control-plaintext"
                  readonly="true"
                />
                <input
                  v-else
                  :value="variant.join_seminar_place"
                  class="form-control-plaintext"
                  readonly="true"
                />
              </div>
              <div class="col-4 mb-2">
                <label class="badge bg-secondary">受講日</label>
                <input
                  :value="variant.join_seminar_date"
                  class="form-control-plaintext"
                  readonly="true"
                />
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div
              class="col-1 offset-11"
              v-if="chk_checked_item('m_join_seminar')"
            >
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('m_join_seminar')"
                  @click="toggle_check_action('m_join_seminar')"
                >
                  <i :class="get_class_check_item_icon('m_join_seminar')"></i>
                </button>
              </div>
            </div>
            <div v-else class="col-2 offset-10">
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('m_join_seminar')"
                  @click="toggle_check_action('m_join_seminar')"
                >
                  <i :class="get_class_check_item_icon('m_join_seminar')"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="container mb-4 pt-2 border border-2">
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-6">
              <p class="form-control-plaintext">ライセンス</p>
            </div>
            <div class="col-3">
              <p class="form-control-plaintext">定価</p>
            </div>
            <div class="col-3">
              <p class="form-control-plaintext">販売価格</p>
            </div>
          </div>
          <div
            class="row mb-2"
            v-for="draft_order in draft_orders"
            :key="draft_order"
          >
            <div class="col-6">
              <p
                class="form-control-plaintext"
                v-if="draft_order.license_label"
              >
                {{ draft_order.license_label }}
              </p>
              <p
                class="form-control-plaintext"
                v-else-if="draft_order.sub_label"
              >
                {{ draft_order.sub_label }}
              </p>
            </div>
            <div class="col-2">
              <p class="form-control-plaintext">
                <span v-if="draft_order.sports_year"
                  >({{ draft_order.sports_year }})</span
                >
              </p>
            </div>
            <div class="col-2">
              <p class="form-control-plaintext">
                {{ draft_order.unit_price }}
              </p>
            </div>
            <div class="col-2">
              <input
                type="text"
                v-model="draft_order.list_price"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="container mb-4 pt-2 border border-2">
          {{
            dev_msg(
              '未成年の継続の場合は、参加承諾書の承諾書を確認する必要がある'
            )
          }}
        </div>
        <div>対応履歴</div>
        <div class="container mb-4 pt-2 border border-2">
          <div
            class="row mb-2 pb-2 border-bottom"
            v-if="(app_data || {}).communications"
          >
            <table class="table w-100">
              <thead>
                <tr>
                  <th style="width: 20%">対応日時</th>
                  <th style="width: 12%">対応者</th>
                  <th style="width: auto">対応内容</th>
                  <th style="width: 14%" class="text-center">詳細</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="communication in communication_sort"
                  :key="communication"
                >
                  <td>{{ communication.cre_date_label }}</td>
                  <td>{{ communication.manage_label }}</td>
                  <td>
                    <p class="">{{ communication.comment }}</p>
                    <div
                      v-if="chk_items_disp(communication.id)"
                      class="border-top mt-2 pt-2"
                    >
                      <div
                        class="row mb-1 pb-1 border-bottom"
                        v-for="item in communication.items"
                        :key="item"
                      >
                        <div class="col-3">
                          {{
                            get_list_label(
                              item.application_check_cd,
                              app_check_items
                            )
                          }}
                        </div>
                        <div class="col-2">
                          {{ item.check_flg == 1 ? 'OK' : 'NG' }}
                        </div>
                        <div class="col-7">{{ item.item_comment }}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="d-grid">
                      <button
                        type="button"
                        class="btn-sm btn btn-light btn-outline-secondary"
                        @click="toggle_communication(communication.id)"
                      >
                        {{
                          chk_items_disp(communication.id) ? '閉じる' : '確認'
                        }}
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-center">
              <button
                type="button"
                class="btn-sm btn btn-light btn-outline-secondary"
                @click="toggle_communication_max()"
              >
                {{ app_com_max_disp ? '閉じる' : '全件表示' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4" v-if="join_category_frm_disp(5)">
        <div>写真・書類</div>
        <div class="py-2 px-1 mb-2 border">
          <div class="row">
            <div class="col-12 mb-2">顔写真</div>
            <div class="col-12 col-md-10">
              <div
                class="w-100"
                v-if="
                  typeof get_app_item('mfj_member_assets@path3') === 'object' &&
                  isImage(
                    get_app_item('mfj_member_assets@path3').application_value
                  )
                "
              >
                <img
                  :src="
                    (get_app_item('mfj_member_assets@path3') || {})
                      .application_value
                  "
                  class="w-100"
                />
              </div>
              <div
                v-else-if="
                  typeof get_app_item('mfj_member_assets@path3') === 'object' &&
                  get_app_item('mfj_member_assets@path3').application_value
                "
                class=""
              >
                <a
                  :href="
                    get_app_item('mfj_member_assets@path3').application_value
                  "
                  target="_blank"
                  >書類を確認</a
                >
                <img
                  :src="
                    (get_app_item('mfj_member_assets@path3') || {})
                      .application_value
                  "
                  class="w-100"
                />
              </div>
              <div v-else>未提出</div>
            </div>
            <div class="col-12 col-md-2">
              <div class="text-end">
                <div v-if="edit_mode">
                  <button
                    :class="get_class_check_item_btn('m_photo')"
                    @click="toggle_check_action('m_photo')"
                  >
                    <i :class="get_class_check_item_icon('m_photo')"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="py-2 px-1 mb-2 border">
          <div class="row">
            <div class="col-12 mb-2">
              過去の顔写真(最終更新のライセンス顔写真)
            </div>
          </div>
        </div>
        <div class="py-2 px-1 mb-2 border" v-if="rd_frm_disp">
          <div class="row">
            <div class="col-12 mb-2">
              サーキットライセンス
              {{ dev_msg('RDのみ') }}
            </div>
            <div class="col-12 col-md-10">
              <div
                class="w-100"
                v-if="
                  typeof get_app_item('mfj_member_assets@path3') === 'object'
                "
              >
                <img
                  :src="
                    (get_app_item('mfj_member_assets@path3') || {})
                      .application_value
                  "
                  class="w-100"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="py-2 px-1 mb-2 border" v-if="parent_frm_disp">
          <div class="row">
            <div class="col-12 mb-2">
              親権者確認書類
              {{ dev_msg('未成年のみ') }}
            </div>
            <div class="col-12 col-md-10">
              <div v-for="k in [4, 5]" :key="k">
                <div
                  class="w-100"
                  v-if="
                    typeof get_app_item('mfj_member_assets@path' + k) ===
                    'object'
                  "
                >
                  <img
                    :src="
                      (get_app_item('mfj_member_assets@path' + k) || {})
                        .application_value
                    "
                    class="w-100"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-md-2">
              <div class="text-end">
                <div>
                  <button
                    :class="get_class_check_item_btn('parent_idcard_photo')"
                    @click="toggle_check_action('parent_idcard_photo')"
                  >
                    <i
                      :class="get_class_check_item_icon('parent_idcard_photo')"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="py-2 px-1 mb-2 border" v-if="parent_frm_disp">
          <div class="row">
            <div class="col-12 mb-2">
              親権者顔写真
              {{ dev_msg('未成年のみ') }}
            </div>
            <div class="col-12 col-md-10">
              <div
                class="w-100"
                v-if="
                  typeof get_app_item('mfj_member_assets@path6') === 'object'
                "
              >
                <img
                  :src="
                    (get_app_item('mfj_member_assets@path6') || {})
                      .application_value
                  "
                  class="w-100"
                />
              </div>
            </div>
            <div class="col-12 col-md-2">
              <div class="text-end">
                <div>
                  <button
                    :class="get_class_check_item_btn('parent_photo')"
                    @click="toggle_check_action('parent_photo')"
                  >
                    <i :class="get_class_check_item_icon('parent_photo')"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="request_mode">
      <div class="col-10">
        <div></div>
        <div v-if="request_join">
          <div class="container">
            <div class="row mb-2">
              <div class="col-5">ライセンスNo</div>
              <div class="col-5">
                <!-- <input type="text" v-model="join_obj.license_no" :class="'form-control'" :readonly="false"> -->
                <input
                  type="text"
                  v-model="join_obj.license_no"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">所属(MFJ)</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_obj.affiliation"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">ログインID</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_obj.login_id"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">ログインパス</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_obj.login_pass"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">姓・名</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_obj.name_1"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_obj.name_2"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">セイ・メイ</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_obj.yomi_1"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_obj.yomi_2"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">生年月日</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_obj.birth_date"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">性別</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    :value="get_list_label(join_obj.sex_type, sex_type_cd)"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">郵便番号・都道府県</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_profile_obj[0].postal_cd"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_profile_obj[0].pref_cd"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">市区町村</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_profile_obj[0].address_1"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">建物名・番</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_profile_obj[0].address_2"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">連絡先電話番号1</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_profile_obj[0].tel_1"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">連絡先電話番号2</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_profile_obj[0].tel_2"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">メールアドレス1</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_profile_obj[0].mail_1"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">本人確認書類</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_obj.identify_type"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">顔写真</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_assets_obj[0].identify_type"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">サーキット名/ライセンス</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_circuit_license_obj[0].circuit_id"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_circuit_license_obj[0].circuit_license_no"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">入会申請日/承認日</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_obj.application_date"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_obj.permission_date"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-5">親権者:姓・名</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_parent_obj[0].name_1"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_parent_obj[0].name_2"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">親権者:セイ・メイ</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_parent_obj[0].yomi_1"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_parent_obj[0].yomi_2"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">親権者:生年月日</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_parent_obj[0].birth_date"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">親権者:性別</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    :value="
                      get_list_label(join_parent_obj[0].sex_type, sex_type_cd)
                    "
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-6">
                <label class="badge bg-secondary">商品名</label>
              </div>
              <div class="col-3">
                <label class="badge bg-secondary">単価</label>
              </div>
              <div class="col-3">
                <label class="badge bg-secondary">価格</label>
              </div>
            </div>
            <div
              class="row"
              v-for="draft_order in draft_orders"
              :key="draft_order"
            >
              <div class="col-6">
                <p class="form-control-plaintext">
                  {{ draft_order.license_sub_license_idlabel }}
                  <span v-if="draft_order.sub_license_id > 0">(付帯あり)</span>
                </p>
              </div>
              <div class="col-3">
                <label class="badge bg-secondary">単価</label>
                <p class="form-control-plaintext">
                  {{ number_format(draft_order.unit_price) }}
                </p>
              </div>
              <div class="col-3">
                <label class="badge bg-secondary">価格</label>
                <p class="form-control-plaintext">
                  {{ number_format(draft_order.list_price) }}
                </p>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-4 offset-4">
                <div
                  class="d-grid"
                  v-if="chk_relation_type_editable('/application/data')"
                >
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="app_update_join()"
                  >
                    申請承認する
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="request_circuit" class="">
          <div
            class="container mb-2 border-bottom"
            v-for="variant in get_selected_variants_filter({ join_3hour: 1 })"
            :key="variant"
          >
            <div class="row">
              <div>サーキット照会依頼</div>
            </div>
            <div class="row mb-2">
              <div class="col-4">氏名</div>
              <div class="col-8">
                <p class="form-control-plaintext">
                  {{ (app_data.member || {}).name_label }}
                  <!-- {{
                    (get_app_item('mfj_member_data@name_1') || {})
                      .application_value
                  }} -->
                </p>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">依頼日時</div>
              <div class="col-8">
                {{
                  variant.join_3hour_circuit_chk_req_date
                    ? variant.join_3hour_circuit_chk_req_date
                    : '--'
                }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">依頼先</div>
              <div class="col-8">
                <dl>
                  <dt>サーキット</dt>
                  <dd>
                    {{
                      get_list_label(
                        variant.join_3hour_circuit_id,
                        circuit_list
                      )
                    }}
                  </dd>
                  <dt>メールアドレス</dt>
                  <dd>
                    {{
                      get_list_column(
                        variant.join_3hour_circuit_id,
                        circuit_list,
                        'mail_address'
                      )
                    }}
                  </dd>
                  <dt>担当</dt>
                  <dd>
                    {{
                      get_list_column(
                        variant.join_3hour_circuit_id,
                        circuit_list,
                        'manager_label'
                      )
                    }}
                  </dd>
                </dl>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">担当者記名</div>
              <div class="col-8">
                {{
                  variant.join_3hour_circuit_chk_ans_signature
                    ? variant.join_3hour_circuit_chk_ans_signature
                    : '--'
                }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">対応日時</div>
              <div class="col-8">
                {{
                  variant.join_3hour_circuit_chk_ans_date
                    ? variant.join_3hour_circuit_chk_ans_date
                    : '--'
                }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">照会結果</div>
              <div class="col-4">
                {{
                  variant.join_3hour_circuit_chk_ans_data_1
                    ? variant.join_3hour_circuit_chk_ans_data_1
                    : '--'
                }}
              </div>
              <div class="col-4">
                {{
                  variant.join_3hour_circuit_chk_ans_data_2
                    ? variant.join_3hour_circuit_chk_ans_data_2
                    : '--'
                }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-2 offset-5">
                <div
                  class="d-grid"
                  v-if="chk_relation_type_editable('/application/data')"
                >
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="
                      app_update_communication_send_circuit(
                        variant.draft_order_id
                      )
                    "
                  >
                    確認依頼送信
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="request_correction">
          <div class="row">
            <div class="col-4">▼チェック箇所</div>
            <div class="col-8">▼依頼内容</div>
          </div>
          <div
            class="row mb-2"
            v-for="check_cd in app_check_items_correction"
            :key="check_cd"
          >
            <div class="col-4">
              {{ check_cd.label }}
            </div>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                v-model="check_cd.item_comment"
              />
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4">通信欄</div>
            <div class="col-8">
              <textarea
                class="form-control"
                v-model="app_checked_comment"
              ></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <div class="col-4">
              <div
                class="d-grid"
                v-if="chk_relation_type_editable('/application/data')"
              >
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="app_update_communication('correction')"
                >
                  訂正依頼
                </button>
              </div>
            </div>
            <div class="col-2 offset-2">
              <div class="d-grid">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-light"
                  @click="close_request_form()"
                >
                  閉じる
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2">
        <div>
          <button
            type="button"
            class="btn btn-outline-secondary btn-light"
            @click="close_request_form()"
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
    <div class="row" v-else-if="isRejectData">
      <div class="col-2">
        <div class="d-grid">
          <button
            type="button"
            class="btn btn-light btn-outline-secondary"
            @click="back()"
          >
            戻る
          </button>
        </div>
      </div>
      <div class="col-8">
        <p class="alert alert-warning">取り消されたデータです。</p>
      </div>
    </div>
    <div class="row" v-else-if="finish_mode">
      <div class="col-1"></div>
      <div class="col-10">
        <p class="alert alert-success">登録済です。</p>
      </div>
      <div class="col-1"></div>
    </div>
    <div class="row" v-else-if="charge_mode">
      <div class="col-1"></div>
      <div class="col-10">
        <p class="alert alert-warning">決済待ちです。</p>
      </div>
      <div class="col-1">
        <div class="d-grid">
          <button type="button" class="btn btn-danger" @click="app_reject()">
            申請取消
          </button>
        </div>
      </div>
    </div>
    <div class="row" v-else-if="editable_mode && edit_mode">
      <div class="col-1">
        <div
          class="d-grid"
          v-if="chk_relation_type_editable('/application/data')"
        >
          <button
            type="button"
            class="btn btn-outline-secondary btn-light"
            @click="edit_cancel()"
          >
            対応解除
          </button>
        </div>
      </div>
      <div class="col-10">
        <div class="row" v-if="app_data?.member?.trans_period == 1">
          <div class="text-center py-2">
            <p class="alert alert-info">12/23-翌1/31以降パッケージ料金対象者</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-info"
                @click="app_send_correction()"
              >
                訂正依頼
              </button>
            </div>
          </div>
          <div class="col">
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-info"
                @click="app_update_communication('save')"
              >
                途中保存
              </button>
            </div>
          </div>
          <div class="col">
            <div class="d-grid" v-if="chk_join">
              <button
                type="button"
                class="btn btn-primary"
                @click="app_update_new_license()"
              >
                申請を承認する
              </button>
            </div>
            <div class="d-grid" v-else>
              <span class="btn btn-secondary" disabled="disabled"
                >申請承認</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-1">
        <div
          class="d-grid"
          v-if="chk_relation_type_editable('/application/data')"
        >
          <button type="button" class="btn btn-danger" @click="app_reject()">
            申請取消
          </button>
        </div>
      </div>
    </div>
    <div class="row" v-else-if="editable_mode">
      <div class="col-2">
        <div class="d-grid">
          <button
            type="button"
            class="btn btn-light btn-outline-secondary"
            @click="back()"
          >
            戻る
          </button>
        </div>
      </div>
      <div class="col-4 offset-2">
        <div
          class="d-grid"
          v-if="chk_relation_type_editable('/application/data')"
        >
          <button type="button" class="btn btn-info" @click="edit_start">
            操作開始
          </button>
        </div>
      </div>
    </div>
    <div
      class="row"
      v-else-if="
        app_data.application_check_type == 200 ||
        app_data.application_check_type == 100 ||
        app_data.application_check_type == 120 ||
        app_data.application_check_type == 340 ||
        app_data.application_check_type == 600
      "
    >
      <div class="col-10"></div>
      <div class="col-2">
        <div
          class="d-grid"
          v-if="chk_relation_type_editable('/application/data')"
        >
          <button
            type="button"
            class="btn btn-warning"
            @click="edit_cancel_force()"
          >
            強制解除
          </button>
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-10">
        <p class="alert alert-info">
          <span v-if="app_data.application_check_type == 100">申請中です</span>
          <span v-else-if="app_data.application_check_type == 120"
            >再申請されました</span
          >
          <span v-else-if="app_data.application_check_type == 200"
            >確認中です</span
          >
          <span v-else-if="app_data.application_check_type == 300"
            >サーキット回答待です</span
          >
          <span v-else-if="app_data.application_check_type == 340"
            >サーキット回答済です</span
          >
          <span v-else-if="app_data.application_check_type == 360"
            >書類待ちです</span
          >
          <span v-else-if="app_data.application_check_type == 400"
            >決済待です</span
          >
          <span v-else-if="app_data.application_check_type == 403"
            >決済中です</span
          >
          <span v-else-if="app_data.application_check_type == 420"
            >決済支払待ち</span
          >
          <span v-else-if="app_data.application_check_type == 423"
            >コンビニ支払済</span
          >
          <span v-else-if="app_data.application_check_type == 426"
            >コンビニ支払済</span
          >
          <span v-else-if="app_data.application_check_type == 430"
            >アンケート未回答</span
          >
          <span v-else-if="app_data.application_check_type == 440"
            >講習未受講</span
          >
          <span v-else-if="app_data.application_check_type == 500">完了</span>
          <span v-else-if="app_data.application_check_type == 600"
            >訂正依頼中</span
          >
        </p>
      </div>
      <div class="col-1">
        <div
          class="d-grid"
          v-if="chk_relation_type_editable('/application/data')"
        >
          <button type="button" class="btn btn-danger" @click="app_reject()">
            申請取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
<script>
import { mapState } from 'vuex'
// import BsPageTitle from '../../molecules/BsPageTitle.vue'
// import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
// import '../../assets/bootstrap/css/sc.css';
import config from '../../../const'
import Common from '../../../common/common'
import ImageWithZoom from '@/components/molecules/ImageWithZoom.vue'
import moment from 'moment'

export default {
  name: 'AppFormView_1000',
  data: function () {
    return {
      // page_mode: 'kiyaku',
      // update_result: false,
      // update_error: false,
      // passwd_mode: 'chk_application',
      // message: 'メールアドレスの変更を行っています。'
      app_checked_items: [],
      app_checked_comment: '',
      action_mode: 'view',
      request_type: '',
      ownchk_list: [
        {
          key: 0,
          label: '保有していない'
        },
        {
          key: 1,
          label: '保有していた'
        }
      ],
      app_com_items_disp: [],
      app_com_max_disp: false,
      member_document: '',
      parent_document: '',

      join_obj: {},
      join_profile_obj: [],
      join_assets_obj: [],
      join_circuit_license_obj: [],
      join_parent_obj: [],
      join_license_obj: []
    }
  },
  components: {
    ImageWithZoom
    //   BsPageTitle,
    //   BsSelect,
    //   BsMsgAlert,
    // BsCheckBox,
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    async toggle_communication(com_id) {
      if (this.chk_items_disp(com_id)) {
        const idx = this.app_com_items_disp.findIndex(tmp => tmp == com_id)
        this.app_com_items_disp.splice(idx, 1)
      } else if (typeof this.app_com_items_disp === 'object') {
        this.app_com_items_disp.push(com_id)
      }
    },
    async toggle_communication_max() {
      if (this.app_com_max_disp) {
        this.app_com_max_disp = false
      } else {
        this.app_com_max_disp = true
      }
    },
    async toggle_check_action(key) {
      console.log('toggle_check_action', key)
      console.log(
        'toggle_check_action this.app_check_items1',
        this.app_checked_items
      )
      if (this.chk_checked_item(key)) {
        const idx =
          typeof this.app_checked_items === 'object'
            ? this.app_checked_items.findIndex(item => item == key)
            : false
        if (idx >= 0) {
          this.app_checked_items.splice(idx, 1)
        }
      } else {
        this.app_checked_items.push(key)
      }
      console.log(
        'toggle_check_action this.app_check_items2',
        this.app_checked_items
      )
    },
    async app_reject() {
      // this.$emit('parentFuncAppReject');
      this.update_app_cancel('申請取消')
    },
    async app_update() {
      // this.$emit('parentFuncAppUpdate');
      this.update_app_check_type(false, '更新')
    },
    async app_wait_parent_accept() {
      // this.$emit('parentFuncWaitParentAccept');
      this.update_app_check_type(360, '書類待ち')
    },
    async app_update_chk() {
      // this.$emit('parentFuncAppUpdate');
      this.update_app_check_type(false, '更新')
    },

    async set_communication_param(type) {
      const params = {
        id: 0,
        stat: 1,
        application_id: (this.app_data || {}).id ? (this.app_data || {}).id : 0,
        application_type: 1300,
        mail_address: '',
        manage_id: this.$store.state.auth.userId,
        comment:
          type == 'save'
            ? '途中保存'
            : type == 'join'
            ? '継続・追加承認'
            : type == 'circuit'
            ? '確認依頼'
            : this.app_checked_comment,
        items: []
      }
      const tmp_item = {
        id: 0,
        stat: 1,
        application_id: (this.app_data || {}).id ? (this.app_data || {}).id : 0,
        communication_id: 0,
        application_check_cd: '',
        check_flg: '',
        application_label: '',
        item_comment: ''
      }
      if (
        typeof this.app_check_items === 'object' &&
        Object.keys(this.app_check_items).length > 0
      ) {
        Object.values(this.app_check_items).forEach(check_item => {
          const item = { ...tmp_item }
          item.application_check_cd = check_item.key
          if (this.chk_checked_item(check_item.key)) {
            item.check_flg = 1
          } else {
            item.check_flg = 0
            item.item_comment =
              type == 'correction' ? check_item.item_comment : ''
          }
          params.items.push(item)
        })
      }
      return params
    },
    async app_update_communication_send_circuit(draft_order_id) {
      // await this.app_update_communication('circuit');
      const params = this.draft_orders.find(
        draft_order => draft_order.draft_order_id == draft_order_id
      )
      if (params) {
        params.join_3hour_circuit_chk_req_manage_id =
          this.$store.state.auth.userId
        params.join_3hour_circuit_chk_req_date = Common.getNowDateStr()
        this.$emit('parentFuncCircuitChk', params, 'circuit')
        await this.close_request_form()
      } else {
        alert('サーキット確認できません')
      }
    },
    async app_update_communication(type) {
      this.$emit('parentFuncSwitchLoading', true)
      const params = await this.set_communication_param(type)
      this.$emit('parentFuncAppUpdateCommunication', params, type)
      await this.close_request_form()
    },

    // form開ける
    async app_send_correction() {
      // this.$emit('parentFuncSendCircuitCheck');
      Common.moveToTop()
      this.request_type = 'correction'
      // this.update_app_check_type(300, 'サーキット依頼状態');
    },
    async app_send_circuit_check() {
      // this.$emit('parentFuncSendCircuitCheck');
      this.request_type = 'circuit'
      // this.update_app_check_type(300, 'サーキット依頼状態');
    },
    // form閉じる
    async close_request_form() {
      // this.$emit('parentFuncSendCircuitCheck');
      this.request_type = ''
      // this.update_app_check_type(300, 'サーキット依頼状態');
    },

    // 承認する
    async app_update_new_license() {
      const m_id = (this.app_data.member || {}).id
      const post_url = config.BASE_API_URL + '/sales/add'
      const params = {
        id: 0,
        m_id: m_id,
        application_id: this.app_data.id,
        regist_id: this.regist_data.id,
        amount: 0,
        sales_type: 'request',
        charge_type: 'CREDIT', //default
        sales_orders: []
      }

      if (typeof this.draft_orders === 'object') {
        Object.values(this.draft_orders).forEach(draft_order => {
          params.sales_orders.push({
            id: 0,
            sales_id: 0,
            application_id: this.app_data.id,
            variant_id: draft_order.variant_id,
            sports_year: draft_order.sports_year,
            unit_price: draft_order.unit_price,
            num: draft_order.num,
            list_price: draft_order.list_price
          })
          params.amount += parseInt(draft_order.list_price)
        })
      }

      let result = false
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            result = true
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            result = false
          } else {
            console.log('error update status 200 error')
            result = false
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(async () => {
          if (result) console.log('result')
          if (parseInt(params.amount) > 0) {
            const c_params = await this.set_communication_param('join')
            c_params.amount = params.amount
            this.$emit('parentFuncUpdateMemberLicense', m_id, c_params)
          } else {
            await this.app_update_0yen_license()
          }
          this.$forceUpdate()
        })
    },
    // 0円追加
    async app_update_0yen_license() {
      const member = this.app_data?.member
        ? { ...this.app_data?.member }
        : false

      const up_license =
        member && typeof member.member_license === 'object'
          ? [...member.member_license]
          : []
      const up_insurance =
        member && typeof member.insurance === 'object'
          ? [...member.insurance]
          : []
      const join_license_tmp = []

      let fix_flg = false
      if (typeof this.draft_orders === 'object') {
        Object.values(this.draft_orders).forEach(draft_order => {
          // params.sales_orders.push({
          //   id: 0,
          //   sales_id: 0,
          //   application_id: this.app_data.id,
          //   variant_id: draft_order.variant_id,
          //   sports_year: draft_order.sports_year,
          //   unit_price: draft_order.unit_price,
          //   num: draft_order.num,
          //   list_price: draft_order.list_price
          // })
          // params.amount += parseInt(draft_order.list_price)

          const start = moment().add(1, 'd').format('YYYY-MM-DD')
          const start_num = parseInt(moment().add(1, 'd').format('YYYYMMDD'))
          // const start_MD = moment().add(1, 'd').format('MMDD')
          const end = moment({
            years: parseInt(draft_order.sports_year) + 1,
            months: 2,
            days: 31
          }).format('YYYY-MM-DD')
          if (draft_order.license_id > 0) {
            const seminar_type = draft_order.join_seminar_type
            const license_start =
              parseInt(draft_order.sports_year + '0401') > start_num
                ? draft_order.sports_year + '-04-01'
                : start
            const fixed =
              draft_order.join_3hour == 1
                ? 1
                : seminar_type == 'circuit' ||
                  seminar_type == false ||
                  seminar_type == null
                ? 1
                : 0
            fix_flg = fixed == 1 ? true : fix_flg

            up_license.push({
              id: 0,
              stat: 1,
              m_id: member.id,
              fixed: fixed,
              payment_flg: 1,
              license_cd: draft_order.license_id,
              license_year: draft_order.sports_year,
              license_term_start_date: license_start,
              license_term_end_date: end
            })
            join_license_tmp.push(parseInt(draft_order.license_id))
            // 基本的にピットクルーが付帯ライセンスなので、講習はなしと考えて良いはず
            if (
              draft_order.sub_license_id &&
              parseInt(draft_order.sub_license_id) > 0 &&
              !join_license_tmp.includes(parseInt(draft_order.sub_license_id))
            ) {
              up_license.push({
                id: 0,
                stat: 1,
                m_id: member.id,
                // PITピットクルーは講習なしなのでfixさせる
                fixed: 1,
                payment_flg: this.selected_charge_type == 'creditcard' ? 1 : 0,
                license_cd: draft_order.sub_license_id,
                license_year: draft_order.sports_year,
                license_term_start_date: license_start,
                license_term_end_date: end
              })
              join_license_tmp.push(parseInt(draft_order.sub_license_id))
            }
          } else if (
            draft_order.license_id == 0 &&
            draft_order.article_category == 1
          ) {
            // 保険期間は、fix_flgが1の場合は決済日(この処理実行日)の翌日がスタートとなる
            const insurance_start =
              parseInt(draft_order.sports_year + '0401') > start_num
                ? draft_order.sports_year + '-04-01'
                : start
            up_insurance.push({
              id: 0,
              stat: 1,
              // fixed: (fix_flg)? 1: 0,
              fixed: 1,
              m_id: member.id,
              insurance_type: draft_order.variant_sort,
              sports_year: draft_order.sports_year,
              start_date: insurance_start,
              end_date: end
            })
          }
        })
      }
      member.member_license = up_license
      member.insurance = up_insurance

      await this.basicPosts_I(
        config.BASE_API_URL + '/member/edit/' + member.id,
        member
      )
        .then(async response => {
          console.log('member_license_update response', response)
        })
        .catch(async err => {
          console.log(err)
        })
        .finally(async () => {
          const c_params = await this.set_communication_param('join')
          c_params.amount = 0
          this.$emit('parentFuncUpdateMemberLicense', member.id, c_params)
          this.$forceUpdate()
        })
    },
    // 参加OK(非使用)
    async app_update_join() {
      const params = this.join_obj
      params.login_pass = params.license_no
      params.profile =
        typeof this.join_profile_obj === 'object' &&
        this.join_profile_obj.length > 0
          ? this.join_profile_obj
          : false
      params.member_assets =
        typeof this.join_assets_obj === 'object' &&
        this.join_assets_obj.length > 0
          ? this.join_assets_obj
          : false
      params.circuit_license =
        typeof this.join_circuit_license_obj === 'object' &&
        this.join_circuit_license_obj.length > 0
          ? this.join_circuit_license_obj
          : false
      params.member_parent =
        typeof this.join_circuit_license_obj === 'object' &&
        this.join_circuit_license_obj.length > 0
          ? this.join_circuit_license_obj
          : false
      params.member_license =
        typeof this.join_license_obj === 'object' &&
        this.join_license_obj.length > 0
          ? this.join_license_obj
          : false
      params.member_insurance =
        typeof this.join_insurance_obj === 'object' &&
        this.join_insurance_obj.length > 0
          ? this.join_insurance_obj
          : false

      const post_url = config.BASE_API_URL + '/member/edit'

      let m_id = false
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            m_id = response.data.body[0].id
            await this.app_order(m_id)
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            m_id = false
          } else {
            console.log('error update status 200 error')
            m_id = false
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(async () => {
          // await this.app_order(m_id);
          const c_params = await this.set_communication_param('join')
          this.$emit('parentFuncUpdateMemberLicense', m_id, c_params)
          await this.close_request_form()
          this.$forceUpdate()
        })
    },
    async app_order(m_id) {
      const post_url = config.BASE_API_URL + '/sales/add'
      const params = {
        id: 0,
        m_id: m_id,
        application_id: this.app_data.id,
        regist_id: this.regist_data.id,
        sales_type: 'request',
        charge_type: 'CREDIT', //default
        amount: 0,
        sales_orders: []
      }

      if (typeof this.draft_orders === 'object') {
        Object.values(this.draft_orders).forEach(draft_order => {
          params.sales_orders.push({
            id: 0,
            sales_id: 0,
            application_id: this.app_data.id,
            variant_id: draft_order.variant_id,
            sports_year: draft_order.sports_year,
            unit_price: draft_order.unit_price,
            num: draft_order.num,
            list_price: draft_order.list_price
          })
          params.amount += parseInt(draft_order.list_price)
        })
      }

      let result = false
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            result = true
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            result = false
          } else {
            console.log('error update status 200 error')
            result = false
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(async () => {
          if (result) console.log('result')
          this.$forceUpdate()
        })
    },
    async app_set_join() {
      this.request_type = 'join'

      // // member_data
      // this.join_obj = {
      //   id: 0,
      //   // license_no: (this.get_app_item('mfj_member_data@license_no') || {}).application_value,
      //   // affiliation: (this.get_app_item('mfj_member_data@affiliation') || {}).application_value,
      //   license_no: '',
      //   affiliation: 'mfj',
      //   login_id: (this.get_app_item('mfj_member_data@login_id') || {})
      //     .application_value,
      //   // login_pass: (this.get_app_item('mfj_member_data@login_pass') || {}).application_value,
      //   login_pass: '',
      //   name_1: (this.get_app_item('mfj_member_data@name_1') || {})
      //     .application_value,
      //   name_2: (this.get_app_item('mfj_member_data@name_2') || {})
      //     .application_value,
      //   yomi_1: (this.get_app_item('mfj_member_data@yomi_1') || {})
      //     .application_value,
      //   yomi_2: (this.get_app_item('mfj_member_data@yomi_2') || {})
      //     .application_value,
      //   birth_date: (this.get_app_item('mfj_member_data@birth_date') || {})
      //     .application_value,
      //   sex_type: (this.get_app_item('mfj_member_data@sex_type') || {})
      //     .application_value,
      //   identify_type: (
      //     this.get_app_item('mfj_member_data@identify_type') || {}
      //   ).application_value,
      //   application_date: (
      //     this.get_app_item('mfj_member_data@application_date') || {}
      //   ).application_value,
      //   permission_date: (
      //     this.get_app_item('mfj_member_data@permission_date') || {}
      //   ).application_value,
      // };

      // this.join_profile_obj.push({
      //   id: 0,
      //   postal_cd: (this.get_app_item('mfj_member_profile@postal_cd') || {})
      //     .application_value,
      //   pref_cd: (this.get_app_item('mfj_member_profile@pref_cd') || {})
      //     .application_value,
      //   address_1: (this.get_app_item('mfj_member_profile@address_1') || {})
      //     .application_value,
      //   address_2: (this.get_app_item('mfj_member_profile@address_2') || {})
      //     .application_value,
      //   tel_1: (this.get_app_item('mfj_member_profile@tel_1') || {})
      //     .application_value,
      //   tel_2: (this.get_app_item('mfj_member_profile@tel_2') || {})
      //     .application_value,
      //   mail_1: (this.get_app_item('mfj_member_profile@mail_1') || {})
      //     .application_value,
      //   mail_2: (this.get_app_item('mfj_member_profile@mail_2') || {})
      //     .application_value,
      //   mail_flg: (this.get_app_item('mfj_member_profile@mail_flg') || {})
      //     .application_value,
      // });

      // const asset_type_lists = [
      //   false,
      //   400,
      //   400,
      //   100,
      //   450,
      //   450,
      //   150,
      //   false,
      //   false,
      //   false,
      //   910,
      // ];
      // if (!this.parent_frm_disp) {
      //   asset_type_lists[4] = false;
      //   asset_type_lists[5] = false;
      //   asset_type_lists[6] = false;
      // }
      // asset_type_lists.forEach((type_cd, index) => {
      //   if (type_cd) {
      //     this.join_assets_obj.push({
      //       id: 0,
      //       type: type_cd,
      //       path: (this.get_app_item('mfj_member_assets@path' + index) || {})
      //         .application_value,
      //     });
      //   }
      // });
      // this.join_circuit_license_obj.push({
      //   id: 0,
      //   circuit_id: (
      //     this.get_app_item('mfj_member_circuit_license.circuit_id') || {}
      //   ).application_value,
      //   circuit_license_no: (
      //     this.get_app_item(
      //       'mfj_member_circuit_license.circuit_license_no'
      //     ) || {}
      //   ).application_value,
      // });

      // this.join_parent_obj.push({
      //   id: 0,
      //   license_no: (this.get_app_item('mfj_member_parent@license_no') || {})
      //     .application_value,
      //   name_1: (this.get_app_item('mfj_member_parent@name_1') || {})
      //     .application_value,
      //   name_2: (this.get_app_item('mfj_member_parent@name_2') || {})
      //     .application_value,
      //   yomi_1: (this.get_app_item('mfj_member_parent@yomi_1') || {})
      //     .application_value,
      //   yomi_2: (this.get_app_item('mfj_member_parent@yomi_2') || {})
      //     .application_value,
      //   birth_date: (this.get_app_item('mfj_member_parent@birth_date') || {})
      //     .application_value,
      //   sex_type: (this.get_app_item('mfj_member_parent@sex_type') || {})
      //     .application_value,
      //   identify_type: (
      //     this.get_app_item('mfj_member_parent@identify_type') || {}
      //   ).application_value,
      // });
    },
    // 通常処理開始
    async edit_start() {
      this.$emit('parentFuncSwitchLoading', true)
      this.$emit('parentFuncEditStart')
    },
    async edit_cancel() {
      this.$emit('parentFuncSwitchLoading', true)
      this.$emit('parentFuncEditCancel')
    },
    async edit_cancel_force() {
      this.$emit('parentFuncSwitchLoading', true)
      this.$emit('parentFuncEditCancel')
    },

    // application_check_typeを更新する(ステータス)
    async update_app_check_type(check_type, type_label) {
      const params = { ...this.app_data }
      if (check_type) params.application_check_type = check_type
      this.$emit('parentFuncAppUpdate', params, type_label)
    },
    // application_check_typeを更新する(ステータス)
    async update_app_cancel(type_label) {
      const params = { ...this.app_data }
      params.stat = 9
      this.$emit('parentFuncAppUpdate', params, type_label)
    },
    chk_val_(value) {
      if (value) {
        return value
      }
      return '--'
    }
  },
  props: {
    app_data: {
      type: Object,
      default: () => {}
    },
    regist_data: {
      type: Object,
      default: () => {}
    },
    app_check_cd: {
      type: Array,
      default: () => []
    },
    app_check_type: {
      type: Array,
      default: () => []
    },
    sex_type_cd: {
      type: Array,
      default: () => []
    },
    circuit_list: {
      type: Array,
      default: () => []
    },
    draft_orders: {
      type: Array,
      default: () => []
    },
    pref_cd: {
      type: Array,
      default: () => []
    },
    member_document_cd: {
      type: Array,
      default: () => []
    },
    step_mode: {
      type: String,
      default: 'kiyaku'
    }
  },
  computed: {
    isRejectData: function () {
      if (this.app_data?.stat == 9) {
        return true
      }
      return false
    },
    isImage: function () {
      return function (url_path) {
        return /\.(jpg|jpeg|png|gif|bmp|webp|svg|avif)$/i.test(url_path)
      }
    },
    ...mapState({}),
    license_filter_sort: function () {
      const member_license = this.app_data.member.member_license
      return function (license_class) {
        if (typeof member_license === 'object') {
          return [...member_license]
            .filter(
              license =>
                parseInt(license.license_class) == parseInt(license_class)
            )
            .sort((a, b) => {
              if (parseInt(a.license_year) > parseInt(b.license_year)) {
                return -1
              } else {
                return 1
              }
            })
        }
        return false
      }
    },
    get_selected_variants_filter: function () {
      const draft_orders = this.draft_orders
      return function (params) {
        if (typeof draft_orders === 'object') {
          return draft_orders.filter(draft_order => {
            let ret = false
            if (typeof params === 'object') {
              Object.keys(params).forEach(key => {
                if (draft_order[key] == params[key]) {
                  ret = true
                }
              })
            }
            return ret
          })
        }
        return false
      }
    },

    // 継続商品が含まれているか
    join_category_frm_disp: function () {
      const draft_orders = this.draft_orders
      return function (article_category) {
        if (
          typeof draft_orders === 'object' &&
          draft_orders.find(
            draft_order => draft_order.article_category == article_category
          )
        ) {
          return true
        }
        return false
      }
    },

    join_3hour_frm_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(
          draft_order =>
            draft_order.join_3hour == 1 && draft_order.article_category == 4
        )
      ) {
        return true
      }
      return false
    },
    // 3時間証明サーキット確認済
    join_3hour_frm_circuit_chk_ok: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(draft_order => {
          console.log('join_3hour check draft_order', draft_order)
          if (
            draft_order.join_3hour == 1 &&
            draft_order.join_3hour_circuit_chk_ans_data_1 == 1 &&
            draft_order.join_3hour_circuit_chk_ans_data_2 == 1
          ) {
            return true
          }
          if (
            Array.isArray(this.app_data?.member?.member_license) &&
            this.app_data?.member?.member_license.length > 0 &&
            this.app_data?.member?.member_license?.find(
              license =>
                license.license_cd == draft_order.license_id &&
                draft_order.join_3hour == 1 &&
                parseInt(draft_order.sports_year) - 10 <=
                  parseInt(license.license_year)
            )
          ) {
            return true
          }
          // if (true) return true
          return false
        })
      ) {
        return true
      }
      return false
    },
    // 3時間証明表示
    rd_3hour_frm_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(draft_order => draft_order.join_3hour == 1)
      ) {
        return true
      }
      return false
    },
    // 講習会
    join_seminar_frm_disp: function () {
      if (
        this.join_seminar_web_frm_disp ||
        this.join_seminar_circuit_frm_disp
      ) {
        return true
      }
      return false
    },
    // Web講習
    join_seminar_web_frm_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(draft_order => draft_order.join_seminar_web == 1)
      ) {
        return true
      }
      return false
    },
    // 対面講習選択
    join_seminar_circuit_chk_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(
          draft_order =>
            draft_order.join_seminar_type == 'circuit' &&
            draft_order.article_category == 4
        )
      ) {
        return true
      }
      return false
    },
    // 対面講習
    join_seminar_circuit_frm_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(
          draft_order => draft_order.join_seminar_circuit == 1
        )
      ) {
        return true
      }
      return false
    },
    // 親権者(MPCのみ)
    parent_frm_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(draft_order => draft_order.join_parent_frm == 1)
      ) {
        return true
      }
      return false
    },
    // 参加承諾書(18歳以下)
    parent_accept_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(
          draft_order => draft_order.join_parent_accept == 1
        )
      ) {
        return true
      }
      return false
    },
    //
    chk_items_disp: function () {
      const app_com_items_disp = this.app_com_items_disp
      return function (com_id) {
        if (app_com_items_disp.includes(com_id)) {
          return true
        }
        return false
      }
    },
    chk_join: function () {
      let chk = true
      if (typeof this.app_check_items === 'object') {
        Object.values(this.app_check_items).forEach(check_cd => {
          console.log(
            'AAAAAAAchk_join chk_checked_item',
            check_cd.key,
            this.chk_checked_item(check_cd.key)
          )
          if (this.chk_checked_item(check_cd.key) && chk == true) {
            console.log(
              'cchk_join chk_checked_item',
              check_cd.key,
              this.chk_checked_item(check_cd.key)
            )
            chk = true
          } else {
            chk = false
          }
        })
      }
      return chk
      // let chk2 = true
      // if (typeof this.app_check_cd === 'object') {
      //   Object.values(this.app_check_cd).forEach(check_cd => {
      //     if (this.chk_checked_item(check_cd.key) && chk2 == true) {
      //       chk2 = true
      //     } else {
      //       chk2 = false
      //     }
      //   })
      // }

      // return chk ? chk : chk2 ? chk2 : chk2
    },
    app_check_items: function () {
      const items = [...this.app_check_cd]
        .map(check_cd => {
          check_cd.item_comment = ''
          return check_cd
        })
        //
        .filter(item => {
          if (item.key == 'm_join_3hour') {
            return this.join_3hour_frm_disp ? true : false
          }
          if (item.key == 'm_join_seminar') {
            return this.join_seminar_circuit_chk_disp ? true : false
          }
          // 継続が含まれているか
          // if (item.key == 'm_photo' || item.key == 'm_idcard_photo') {
          if (item.key == 'm_photo') {
            return this.join_category_frm_disp(5) ? true : false
          }
          // 親権者か
          if (item.key.indexOf('parent') < 0) {
            return true
          } else if (this.parent_frm_disp && item.key.indexOf('parent') >= 0) {
            return true
          }
          return false
        })
      // 取得ライセンスに応じて削除する
      // ロードレースF、国内以外は３時間は削除
      // 成人であれば親権者系は必要なし
      // MPC以外は親権者いらんとか
      return items
    },
    app_check_items_correction: function () {
      const items = this.app_check_items.filter(item => {
        if (!this.chk_checked_item(item.key)) {
          return true
        }
        return false
      })
      // 取得ライセンスに応じて削除する
      // ロードレースF、国内以外は３時間は削除
      // 成人であれば親権者系は必要なし
      // MPC以外は親権者いらんとか
      return items
    },
    get_app_check_item: function () {
      const items = this.app_check_items
      return function (key) {
        if (
          typeof items === 'object' &&
          items.find(item => item.application_key == key)
        ) {
          return items.find(item => item.application_key == key)
        }
        return false
      }
    },
    chk_checked_item: function () {
      const checked_items = this.app_checked_items
      const checked = (this.app_data || {}).checked
      return function (key) {
        // const item = get_item(key);
        if (typeof checked === 'object' && checked.includes(key)) {
          return true
        } else if (
          typeof checked_items === 'object' &&
          checked_items.includes(key)
        ) {
          return true
        }
        console.log('not chk_checked_item', key)
        return false
      }
    },
    get_class_check_item_btn: function () {
      const check = this.chk_checked_item
      return function (key) {
        if (check(key)) {
          return 'btn btn-sm btn-warning'
        }
        return 'btn btn-sm btn-light btn-outline-secondary'
      }
    },
    get_class_check_item_icon: function () {
      const check = this.chk_checked_item
      return function (key) {
        if (check(key)) {
          return 'bi bi-check-square'
        }
        return 'bi bi-square'
      }
    },
    app_items: function () {
      return (this.app_data || {}).items ? (this.app_data || {}).items : false
    },
    get_app_item: function () {
      const items = this.app_items
      return function (app_key) {
        if (
          typeof items === 'object' &&
          items.find(item => item.application_key == app_key)
        ) {
          return items.find(item => item.application_key == app_key)
        }
        return false
      }
    },
    get_app_item_value: function () {
      const get_obj = this.get_app_item
      return function (app_key) {
        const get_item = get_obj(app_key)
        if (get_item) {
          return (get_item || {}).application_value
        }
        return false
      }
    },
    get_list_label: function () {
      return function (key, lists) {
        if (
          key &&
          typeof lists === 'object' &&
          lists.find(list => list.key == key)
        ) {
          return (lists.find(list => list.key == key) || {}).label
        }
        return key
      }
    },
    get_list_column: function () {
      return function (key, lists, column) {
        if (
          key &&
          typeof lists === 'object' &&
          lists.find(list => list.key == key)
        ) {
          return (lists.find(list => list.key == key) || {})[column] || ''
        }
        return key
      }
    },
    communication_sort: function () {
      return (this.app_data || {}).communications
        .map(communication => {
          if (!communication.items_disp) {
            communication.items_disp = false
          }
          return communication
        })
        .sort((a, b) => {
          if (parseInt(a.cre_date_num) > parseInt(b.cre_date_num)) {
            return -1
          } else {
            return 1
          }
        })
        .filter((communication, index) => {
          if (this.app_com_max_disp == false && index >= 5) {
            return false
          }
          return true
        })
    },
    input_class: function () {
      if (!this.root_mode) {
        return 'form-control-plaintext'
      } else {
        return 'form-control'
      }
    },
    input_readonly: function () {
      if (!this.root_mode) {
        return true
      } else {
        return false
      }
    },
    input_class_join: function () {
      if (this.request_join) {
        return 'form-control-plaintext'
      } else {
        return 'form-control'
      }
    },
    input_readonly_join: function () {
      if (this.request_join) {
        return true
      } else {
        return false
      }
    },

    req_parent_accept: function () {
      if (
        ((this.app_data || {}).application_check_type == 200 ||
          (this.app_data || {}).application_check_type == 340) &&
        !this.chk_checked_item('parent_accept')
      ) {
        return true
      }
      return false
    },
    no_check_circuit: function () {
      if (
        (this.app_data || {}).application_check_type == 200 &&
        !this.chk_checked_item('m_rd_3hour_circuit')
        // ロードRF,ロード国内のみの処理
      ) {
        return true
      }
      return false
    },

    request_circuit: function () {
      return this.request_type == 'circuit' ? true : false
    },
    request_correction: function () {
      return this.request_type == 'correction' ? true : false
    },
    request_join: function () {
      return this.request_type == 'join' ? true : false
    },
    request_mode: function () {
      if (
        this.request_type == 'circuit' ||
        this.request_type == 'correction' ||
        this.request_type == 'join'
      ) {
        return true
      }
      return false
    },
    root_mode: function () {
      return false
    },
    editable_mode: function () {
      if (this.app_data.editable == 1) {
        return true
      }
      return false
    },
    finish_mode: function () {
      if (this.app_data.application_check_type == 500) {
        return true
      }
      return false
    },
    charge_mode: function () {
      if (this.app_data.application_check_type == 400) {
        return true
      }
      return false
    },
    lock_mode: function () {
      if (this.app_data.editable == 0) {
        return true
      }
      return false
    },
    edit_mode: function () {
      if (
        this.app_data.edit_manage_id > 0 &&
        this.app_data.edit_manage_id == this.$store.state.auth.userId
      ) {
        return true
      }
      return false
    },
    reject_mode: function () {
      return this.step_mode == 'mfj_reject' ? true : false
    },
    approval_mode: function () {
      return this.step_mode == 'mfj_approval' ? true : false
    },
    success_mode: function () {
      return this.step_mode == 'success' ? true : false
    },
    error_mode: function () {
      return this.step_mode == 'error' ? true : false
    }
  },

  async created() {},
  mounted: function () {
    // console.log('tags_list', this.tags_list);

    this.member_document = (
      this.get_app_item('mfj_member_data@identify_type') || {}
    ).application_value
    this.parent_document = (
      this.get_app_item('mfj_member_parent@identify_type') || {}
    ).application_value
  }
}
</script>
